import CashDepositHtml from './customer.cash-deposit.html';
import DepositHtml     from './deposit.html';

export function InvoiceDepositService (
  $q,
  $rootScope,
  $translate,
  $uibModal,
  bigDecimalApi,
  dateParsing,
  messages,
  workshopAPI
) {
  var Deposit = function (invoice, deposit, paymentMethods) {
    this.invoice = invoice;
    this.deposit = deposit || {
      customer_id  : invoice.customer_id,
      date_received: dateParsing.today(),
      invoice_id   : invoice.id,
      payment_type : paymentMethods ? paymentMethods[0].payment_method: '',
      status       : 'O'
    };

    this.deposit.savedAmount = this.deposit.amount;
  };

  Deposit.prototype.validate = function () {
    const self = this;

    /**
     * WOR-3158, allow deposits on quotes.
     *
     * For quotes, there is no balance so we use the subtotal
     * instead to check against. Deposits can be added to
     * quotes as long as they don't exceed the total.
     *
     * TODO: would be nice to change the type check to use the invoice api, but the service needs to be upgraded first.
     */
    const balance         = bigDecimalApi.get(self.invoice.balance_due);
    const currentDeposits = bigDecimalApi.get(self.deposit.savedAmount);
    const deposit         = bigDecimalApi.get(self.deposit.amount);
    const total           = bigDecimalApi.get(self.invoice.total);

    const isValid = self.invoice.invoice_type === 'Q'
      ? total.subtract(currentDeposits).isGreaterThanOrEqualTo(deposit)
      : deposit.isLessThanOrEqualTo(balance);

    return isValid
      ? $q.when(true)
      : $q.reject($translate.instant('JS_SPACE.MESSAGES.DEPOSITS_CANNOT_BE_GREATER_THAN_BALANCE'));
  };

  Deposit.prototype.add = function (index) {
    const self = this;

    return $uibModal.open({
      controller : 'CashDepositCtrl',
      templateUrl: CashDepositHtml,
      windowClass: 'lg-modal',
      backdrop   : 'static',
      keyboard   : false,
      resolve    : {
        customer: () => workshopAPI.get('/customer', self.invoice.customer_id),
        deposit : () => index >= 0
          ? angular.copy(self.invoice.customer_deposits_attributes[index])
          : null,
        integrations: () => workshopAPI.get('/company_integrations'),
        invoice     : () => self.invoice,
        isRefund    : () => false,
        methods     : () => workshopAPI.get('/invoice_payment_methods'),
        terminalId  : (tillpaymentsApi) => tillpaymentsApi.getDefaultUserTerminalId()
      }
    }).result
    .then(result => {
      if (result.terminal) {
        $rootScope.$broadcast('calculateTotals');

        return $q.when(result);
      }

      const deposit = result.deposit;

      if (index >= 0) {
        self.invoice.customer_deposits_attributes[index] = deposit;
      }
      else {
        self.invoice.customer_deposits_attributes.push(deposit);
      }

      $rootScope.$broadcast('calculateTotals');

      return $q.when(deposit);
    });
  };

  Deposit.prototype.refund = function (index) {
    const self    = this;

    if (self.refunding) {
      return $q.reject('Refund in progress');
    }

    const deposit = self.invoice.customer_deposits_attributes[index];

    if (!deposit || !deposit.amount) {
      return $q.reject('Invalid deposit');
    }

    self.refunding = true;

    return $uibModal.open({
      controller : 'CashDepositCtrl',
      templateUrl: CashDepositHtml,
      windowClass: 'lg-modal',
      backdrop   : 'static',
      keyboard   : false,
      resolve    : {
        customer    : () => workshopAPI.get('/customer', self.invoice.customer_id),
        deposit     : () => angular.copy(deposit),
        integrations: () => workshopAPI.get('/company_integrations'),
        invoice     : () => self.invoice,
        isRefund    : () => true,
        methods     : () => workshopAPI.get('/invoice_payment_methods'),
        terminalId  : (tillpaymentsApi) => tillpaymentsApi.getDefaultUserTerminalId()
      }
    }).result
    .then(result => {

      if (result && result.terminal) {
        // Terminal refund already handled by BE — just remove from UI
        self.invoice.customer_deposits_attributes.splice(
          self.invoice.customer_deposits_attributes.indexOf(deposit), 1
        );

        $rootScope.$broadcast('calculateTotals');
        messages.show($translate.instant('JS_SPACE.MESSAGES.CREATED.DEPOSIT_REFUNDED'), 'success');
        return $q.when();
      }

      // Non-terminal: mark destroyed and patch invoice
      deposit._destroy = '1';

      return workshopAPI.patch('invoice', self.invoice, 'invoice')
      .then(updatedInvoice => {
        self.invoice.depositsToDelete.push(deposit);

        self.invoice.customer_deposits_attributes.splice(
          self.invoice.customer_deposits_attributes.indexOf(deposit), 1
        );

        /**
         * Sync the BE's recomputed surcharge/balance fields back into scope so
         * the calculateTotals broadcast below sees fresh data. Without this,
         * hasTillPaySurcharges keeps returning true (against the pre-refund
         * amount) and the surcharge totals row stays visible until a hard
         * refresh.
         **/
        if (updatedInvoice) {
          self.invoice.balance_due                     = updatedInvoice.balance_due;
          self.invoice.total                           = updatedInvoice.total;
          self.invoice.tillpayments_surcharge_amount   = updatedInvoice.tillpayments_surcharge_amount;
          self.invoice.tillpayments_surcharge_subtotal = updatedInvoice.tillpayments_surcharge_subtotal;
          self.invoice.tillpayments_surcharge_tax      = updatedInvoice.tillpayments_surcharge_tax;
        }

        $rootScope.$broadcast('calculateTotals');

        messages.show($translate.instant('JS_SPACE.MESSAGES.CREATED.DEPOSIT_REFUNDED'), 'success');
      });
    })
    .finally(() => {
      self.refunding = false;
    });
  };

  Deposit.prototype.remove = function(index) {
    const self           = this;
    const deletedDeposit = self.invoice.customer_deposits_attributes.splice(index, 1)[0];

    if (deletedDeposit.id) {
      deletedDeposit._destroy = '1';

      self.invoice.depositsToDelete.push(deletedDeposit);
    }

    $rootScope.$broadcast('calculateTotals');
  };

  return Deposit;
}